/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientAttachments
 */
export interface ClientAttachments {
    /**
     * 
     * @type {string}
     * @memberof ClientAttachments
     */
    urlPath?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAttachments
     */
    fileType?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAttachments
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientAttachments
     */
    filename?: string;
}

export function ClientAttachmentsFromJSON(json: any): ClientAttachments {
    return ClientAttachmentsFromJSONTyped(json, false);
}

export function ClientAttachmentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientAttachments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'urlPath': !exists(json, 'urlPath') ? undefined : json['urlPath'],
        'fileType': !exists(json, 'fileType') ? undefined : json['fileType'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
    };
}

export function ClientAttachmentsToJSON(value?: ClientAttachments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'urlPath': value.urlPath,
        'fileType': value.fileType,
        'id': value.id,
        'filename': value.filename,
    };
}


